import { ref, computed } from "vue";

export const READY = "READY";
export const PENDING = "PENDING";
export const ERROR = "ERROR";

export type Ready = { type: typeof READY };
export type Pending = { type: typeof PENDING };
export type Error = { type: typeof ERROR };

export type RequestStatus = Ready | Pending | Error;

export const useRequestStatus = (
  initStatus: RequestStatus = { type: READY },
) => {
  const requestStatus = ref<RequestStatus>(initStatus);

  const isRequestReady = computed(() => requestStatus.value.type === READY);
  const isRequestPending = computed(() => requestStatus.value.type === PENDING);
  const isRequestError = computed(() => requestStatus.value.type === ERROR);

  const setRequestStatus = (newState: RequestStatus) =>
    (requestStatus.value = newState);

  return {
    requestStatus,
    setRequestStatus,
    isRequestReady,
    isRequestPending,
    isRequestError,
  };
};

export default {};
